import mapConfig from '~/salesforce/_map'
import initSalesforce from '~/salesforce/_init'

const FORM_TYPES = ['subscribe', 'personal', 'business']

// Get our configuration, if none is present short circuit
const scriptSrc = document.currentScript?.src

let paramMap = '';
let paramSimulate = ''

if (scriptSrc) {
  const url = new URL(scriptSrc);
  const params = new URLSearchParams(url.search);
  paramMap = params.get('map') ?? '';
  paramSimulate = params.get('simulate') ?? '';
}

if (FORM_TYPES.includes(paramMap)) {
  initSalesforce(mapConfig, paramMap, paramSimulate)
}
